import {
    ArrayInput,
    AutocompleteInput,
    FormDataConsumer,
    required,
    SelectArrayInput,
    SelectInput,
    SimpleForm,
    TextInput,
    useCreate,
    useGetOne,
    useNotify,
} from 'react-admin';
import { Videos } from '../../custom';
import { VIDEO_ENCODING, VIDEO_TYPES } from '../constants';
import {  useState } from 'react';
import Button from '@mui/material/Button';
import { useController } from 'react-hook-form';
import { InputAdornment } from '@mui/material';
import { extractYoutubeVideoId } from '../string-utilities';
import { ContentCopy, Videocam } from '@mui/icons-material';
import useAllowedQualities from '../../hooks/useAllowedQualities';
import FileUpload from './FileUpload';
import { useInfiniteAutocomplete } from '../../hooks/useInfiniteAutocomplete';

const getYouTubeEmbedCode = (type: any, raw_url: string): string => {
    if (type !== 'YOUTUBE') return '';
    const url = type === 'YOUTUBE' ? `https://www.youtube.com/embed/${raw_url}` : '';
    const regex =
        /(?:https?:\/\/)?(?:www\.)?(?:youtube\.com\/(?:watch\?v=|embed\/|v=|v\/|.+\?v=)|youtu\.be\/|youtube\.com\/embed\/)([a-zA-Z0-9_-]{11})/;
    const match = url.match(regex);
    const code = match ? match[1] : '';

    return `https://i.ytimg.com/vi/${code}/hq720.jpg`;
};

const videoNameRender = (choice: Videos) => `${choice?.title}| ${choice?.code}`;
const filterToQueryVideo = (searchText: string) => searchText && { code: `${searchText}` };
const VideoModal = (props: any) => {
    const [title, setTitle] = useState(props?.title || '');
    const [type, setType] = useState('');
    const [rawUrl, setRawUrl] = useState('');
    const [qualities, setQualities] = useState([]);
    const [encodings, setEncodings] = useState(['HLS']);
    const notify = useNotify();
    const [create, { isLoading }] = useCreate();
    const Qualities = useAllowedQualities();
    return (
        <div
            className={
                'fixed top-0 left-0 right-0 bottom-0 z-[100] bg-gray-400 bg-opacity-50 flex flex-col items-center justify-center'
            }
        >
            <div className={'rounded-md bg-white shadow-md max-w-lg'}>
                <SimpleForm toolbar={<></>} defaultValues={{ title }}>
                    <div>
                        <TextInput
                            fullWidth
                            source={'title'}
                            value={title}
                            onChange={e => {
                                setTitle(e.target.value);
                            }}
                            required
                        />
                        <SelectInput
                            source="type"
                            label={'Type'}
                            fullWidth
                            onChange={e => {
                                setTimeout(() => {
                                    if (document.getElementById('youtube-input')) {
                                        document.getElementById('youtube-input')?.focus();
                                    }
                                }, 100);
                                setType(e.target.value);
                            }}
                            choices={VIDEO_TYPES}
                        />
                        <FormDataConsumer>
                            {({ formData, ...rest }) =>
                                formData.type === 'YOUTUBE' ? (
                                    <TextInput
                                        InputProps={{
                                            startAdornment: (
                                                <InputAdornment position="start">
                                                    https://www.youtube.com/embed/
                                                </InputAdornment>
                                            ),
                                        }}
                                        id={'youtube-input'}
                                        label={'Youtube Embed Code'}
                                        fullWidth
                                        onChange={e => {
                                            setRawUrl(e.target.value);
                                        }}
                                        validate={[required()]}
                                        source="raw_url"
                                        {...rest}
                                    />
                                ) : formData.type ? (
                                    <>
                                        <ArrayInput source="qualities" defaultValue={qualities}>
                                            <SelectArrayInput
                                                label={'Video Qualities'}
                                                fullWidth
                                                onChange={e => setQualities(e.target.value)}
                                                choices={Qualities}
                                            />
                                        </ArrayInput>
                                        <ArrayInput source="encodings" defaultValue={encodings}>
                                            <SelectArrayInput
                                                label={'Video Encodings'}
                                                fullWidth
                                                onChange={e => setEncodings(e.target.value)}
                                                choices={VIDEO_ENCODING}
                                            />
                                        </ArrayInput>
                                        {/*<BooleanInput  defaultValue={false} fullWidth source={'drm_enabled'}/>*/}

                                        <FileUpload
                                            type="video"
                                            meta={{
                                                drm_enabled: formData.drm_enabled,
                                                encodings: formData.encodings,
                                                qualities: formData.qualities,
                                            }}
                                            onChange={(e: any) => {
                                                setRawUrl(e);
                                            }}
                                            required={true}
                                            source="rawUrl"
                                            accept="video/*"
                                            multiple={false}
                                        />
                                    </>
                                ) : (
                                    <></>
                                )
                            }
                        </FormDataConsumer>
                        <div className={'flex space-x-2 mt-2 border-t pt-4'}>
                            <Button
                                disabled={isLoading || !rawUrl}
                                onClick={() => {
                                    console.log(title, type, rawUrl);
                                    if (!title || !type || !rawUrl) {
                                        notify('Please fill Title, type and Video Url', {
                                            type: 'error',
                                            messageArgs: {},
                                        });
                                        return;
                                    }
                                    create(
                                        'videos',
                                        {
                                            data: {
                                                processedUrl:
                                                    type === 'YOUTUBE'
                                                        ? `https://www.youtube.com/embed/${rawUrl}`
                                                        : '',
                                                title: title,
                                                qualities: qualities,
                                                encodings: encodings,
                                                thumbnail: getYouTubeEmbedCode(
                                                    type,
                                                    `https://www.youtube.com/embed/${rawUrl}`,
                                                ),
                                                drm_enabled: false,
                                                type: type,
                                                rawUrl: rawUrl,
                                                status: type === 'YOUTUBE' ? 'PROCESSED' : '',
                                            },
                                        },
                                        {
                                            onSuccess: e => {
                                                if (props.onClose) {
                                                    props.onClose(e.id);
                                                }
                                            },
                                        },
                                    );
                                }}
                            >
                                Attach Video
                            </Button>
                            <Button
                                color={'error'}
                                onClick={() => {
                                    if (props.onClose) {
                                        props.onClose('');
                                    }
                                }}
                            >
                                Cancel
                            </Button>
                        </div>
                    </div>
                </SimpleForm>
            </div>
        </div>
    );
};
const VideoAutocompleteInput = (props: any) => {
    const i = useController({ name: props.source });
    const typeController = useController({ name: 'type' });
    const createInputController = useController({ name: 'createNew' });
    const rawUrlController = useController({ name: 'raw_url' });
    const notify = useNotify();
    const [createVideo, setCreateVideo] = useState(false);
    const VideoData = props?.formData?.video || {};

    const { data: selectedVideoData } = useGetOne(
        'videos',
        { id: i.field.value },
        { enabled: !!i.field.value },
    );

    const {
        choices: allChoices,
        isLoading,
        setSearchText,
        handleScroll,
    } = useInfiniteAutocomplete('videos', {
        searchField: 'code',
    });
    const videoCode = VideoData?.code || selectedVideoData?.code;
    if (i.field.value) {
        return (
            <div
                className={
                    'w-full p-4 rounded-md bg-gray-50 mb-4 border border-gray-200 flex justify-between items-center'
                }
            >
                <div className="flex flex-col">
                    <Videocam className={'text-black'} style={{ fontSize: '100px' }} />
                    {videoCode && (
                        <div className="flex items-center gap-1">
                            <div className="text-xs text-blue-600">{videoCode}</div>
                            <Button
                                size="small"
                                onClick={async () => {
                                    try {
                                        await navigator.clipboard.writeText(videoCode);
                                        notify('Video code copied', {
                                            type: 'success',
                                            messageArgs: { _: 'Video code copied' },
                                        });
                                    } catch (error) {
                                        notify('Failed to copy video code', {
                                            type: 'error',
                                            messageArgs: { _: 'Failed to copy video code' },
                                        });
                                    }
                                }}
                            >
                                <ContentCopy fontSize="small" />
                            </Button>
                        </div>
                    )}
                </div>
                <Button
                    color={'error'}
                    onClick={() => {
                        i.field.onChange('');
                    }}
                >
                    Change Video
                </Button>
            </div>
        );
    }
    return (
        <div className={'w-full'}>
            {createVideo && (
                <VideoModal
                    title={props?.formData?.title}
                    onClose={(e: any) => {
                        if (e) {
                            i.field.onChange(e);
                        }
                        setCreateVideo(false);
                    }}
                />
            )}
            <>
                <div className={'flex justify-between items-center'}>
                    <div className={'text-xs text-gray-500'}>Search by video code</div>
                    <div
                        onClick={() => {
                            setCreateVideo(true);
                        }}
                        className={
                            'text-indigo-500 text-sm font-medium py-1 cursor-pointer px-2 hover:bg-indigo-50 transition-all duration-200 rounded'
                        }
                    >
                        Add a New Video
                    </div>
                </div>

                <AutocompleteInput
                    source={props.source || 'video_id'}
                    label={props.label || 'Video'}
                    choices={allChoices}
                    optionText={videoNameRender}
                    optionValue="id"
                    loading={isLoading}
                    setFilter={setSearchText}
                    ListboxProps={{ onScroll: handleScroll }}
                    onChange={(value) => {
                        i.field.onChange(value);
                    }}
                    debounce={500}
                    onPaste={async (e: any) => {
                        const _text = e.clipboardData.getData('Text')?.toLowerCase();
                        if (_text.startsWith('https://www.youtube.com/embed/')) {
                            createInputController.field.onChange(true);
                            rawUrlController.field.onChange(
                                _text.replace('https://www.youtube.com/embed/', ''),
                            );
                            typeController.field.onChange('YOUTUBE');
                        } else if (
                            _text.startsWith('https://www.youtube.com') &&
                            extractYoutubeVideoId(_text)
                        ) {
                            createInputController.field.onChange(true);
                            rawUrlController.field.onChange(extractYoutubeVideoId(_text));
                            typeController.field.onChange('YOUTUBE');
                        }
                    }}
                />
            </>
        </div>
    );
};
export default VideoAutocompleteInput;
